import { useState } from "react";
import  "./AftertasteLevel.css";


const AftertasteLevel = ({data,handleChange, count})=>{
  const [val, setVal] = useState(data.aftertestlevel=== 0?0:data.aftertestlevel);

  function onChangeValue(event) {
    setVal(event.target.value);
    console.log(event.target.value+2);
    handleChange(event);
  }
    return (
  <div class="AftertasteLevelCard" name="aftertestlevel" onChange={onChangeValue}>
    <div class="AftertasteLevel-rating-container">

      <div class="AftertasteLevel-rating">
        <form class="AftertasteLevel-rating-form-1" >

          <label for={`ATL1F-${count}`}>
            <input type="radio"  name="aftertestlevel" class="AftertasteLevel1" id={`ATL1F-${count}`}  value="6"  checked={'' + val === "6"} />
                <div className="aromacircle1"></div>
                <p>6</p>
           </label>

          <label for={`ATL2F-${count}`}>
              <input type="radio" name="aftertestlevel" class="AftertasteLevel2" id={`ATL2F-${count}`} value="6.25" checked={'' + val === "6.25"} />
                <div className="aromacircle2"></div>
               <p className="invisible">.5</p>
           </label>

          <label for={`ATL3F-${count}`}>
              <input type="radio" name="aftertestlevel" class="AftertasteLevel3" id={`ATL3F-${count}`} value="6.5" checked={'' + val === "6.5"} />
                <div className="aromacircle3"></div>
                <p className="invisible">.5</p>
            </label>

          <label for={`ATL4F-${count}`}>
             <input type="radio" name="aftertestlevel" class="AftertasteLevel4" id={`ATL4F-${count}`} value="6.75" checked={'' + val === "6.75"} />
               <div className="aromacircle4"></div>
               <p className="invisible">.5</p>

            </label>

          <label for={`ATL5F-${count}`}>
             <input type="radio" name="aftertestlevel" class="AftertasteLevel5" id={`ATL5F-${count}`} value="7" checked={'' + val === "7"} />
                <div className="aromacircle5"></div>
                <p>7</p>
             </label>
             {/* Didn't change it after this */}
             <label for={`ATL6F-${count}`}>
             <input type="radio" name="aftertestlevel" class="AftertasteLevel6" id={`ATL6F-${count}`} value="7.25" checked={'' + val === "7.25"} />
                <div className="aromacircle6"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ATL7F-${count}`}>
             <input type="radio" name="aftertestlevel" class="AftertasteLevel7" id={`ATL7F-${count}`} value="7.5" checked={'' + val === "7.5"} />
                <div className="aromacircle7"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ATL8F-${count}`}>
             <input type="radio" name="aftertestlevel" class="AftertasteLevel8" id={`ATL8F-${count}`} value="7.75" checked={'' + val === "7.75"} />
                <div className="aromacircle8"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ATL9F-${count}`}v>
             <input type="radio" name="aftertestlevel" class="AftertasteLevel9" id={`ATL9F-${count}`} value="8" checked={'' + val === "8"} />
                <div className="aromacircle9"></div>
                <p>8</p>

             </label>

             <label for={`ATL10F-${count}`}>
             <input type="radio" name="aftertestlevel" class="AftertasteLevel10" id={`ATL10F-${count}`} value="8.25" checked={'' + val === "8.25"} />
                <div className="aromacircle10"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ATL11F-${count}`}>
             <input type="radio" name="aftertestlevel" class="AftertasteLevel11" id={`ATL11F-${count}`} value="8.5" checked={'' + val === "8.5"} />
                <div className="aromacircle11"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ATL12F-${count}`}>
             <input type="radio" name="aftertestlevel" class="AftertasteLevel12" id={`ATL12F-${count}`} value="8.75" checked={'' + val === "8.75"} />
                <div className="aromacircle12"></div>
                <p className="invisible">.5</p>
             </label>


             <label for={`ATL13F-${count}`}>
             <input type="radio" name="aftertestlevel" class="AftertasteLevel13" id={`ATL13F-${count}`} value="9" checked={'' + val === "9"} />
                <div className="aromacircle13"></div>

                <p>9</p>
             </label>

             <label for={`ATL14F-${count}`}>
             <input type="radio" name="aftertestlevel" class="AftertasteLevel14" id={`ATL14F-${count}`} value="9.25" checked={'' + val === "9.25"} />
                <div className="aromacircle14"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ATL15F-${count}`}>
             <input type="radio" name="aftertestlevel" class="AftertasteLevel15" id={`ATL15F-${count}`} value="9.5" checked={'' + val === "9.5"} />
                <div className="aromacircle15"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ATL16F-${count}`}>
             <input type="radio" name="aftertestlevel" class="AftertasteLevel16" id={`ATL16F-${count}`} value="9.75" checked={'' + val === "9.75"} />
                <div className="aromacircle16"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ATL17F-${count}`}>
             <input type="radio" name="aftertestlevel" class="AftertasteLevel17" id={`ATL17F-${count}`} value="10" checked={'' + val === "10"} />
                <div className="aromacircle17"></div>
                <p>10</p>
             </label>



        </form>
      </div>
    </div>
  </div>


    );
}

export default AftertasteLevel;